
export const GET_RESOURCES = 'GET_RESOURCES'
export const SAVE_RESOURCE = 'SAVE_RESOURCE'
export const GET_RESOURCE = 'GET_RESOURCE'
export const GET_USER_RESOURCES = 'GET_USER_RESOURCES'
export const GET_USER_FAVORITES = 'GET_USER_FAVORITES'
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE'
export const FORK_RESOURCE = 'FORK_RESOURCE'
export const RUN_RESOURCE = 'RUN_RESOURCE'
export const RUN_RESOURCE_BY_ID = 'RUN_RESOURCE_BY_ID'
export const DELETE_RESOURCE = 'DELETE_RESOURCE'
export const VOTE_RESOURCE = 'VOTE_RESOURCE'
export const FAVORITE_RESOURCE = 'FAVORITE_RESOURCE'
export const DOWNLOAD_RESOURCE = 'DOWNLOAD_RESOURCE'
export const GET_RESOURCES_SLICED = 'GET_RESOURCES_SLICED'
export const GET_RESOURCES_VIEW = 'GET_RESOURCES_VIEW'
export const SEARCH_RESOURCES = 'SEARCH_RESOURCES'
export const GET_TAGS = 'GET_TAGS'
export const GET_RESOURCES_BY_TAG = 'GET_RESOURCES_BY_TAG'
export const GET_RESOURCE_META = 'GET_RESOURCE_META'
export const GET_RESOURCE_MORE_IMAGES = 'GET_RESOURCE_MORE_IMAGES'

export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CATEGORY = 'GET_CATEGORY'
export const SAVE_CATEGORY = 'SAVE_CATEGORY'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'

export const GET_USERS = 'GET_USERS'
export const GET_USERS_SORTED = 'GET_USERS_SORTED'
export const SAVE_USER = 'SAVE_USER'
export const SAVE_USER_PROFILE = 'SAVE_USER_PROFILE'
export const GET_USER = 'GET_USER'
export const FIND_USER = 'FIND_USER'
export const CREATE_USER = 'CREATE_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const GET_ME = 'GET_ME'
export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const VERIFY_USER = 'VERIFY_USER'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const DO_PASSWORD_RESET = 'DO_PASSWORD_RESET'
export const LOOKUP_USERNAME = 'LOOKUP_USERNAME'
export const DELETE_USER = 'DELETE_USER'

export const SUBMIT_CONTACT_FORM = 'SUBMIT_CONTACT_FORM'